import { Box, IconButton } from '@mui/material'
import { DeleteIcon, FileIcon } from '~components/icons'
import { TextButton } from '~components/web-components'
import { IVesselFile } from '~hooks/queries/vessels/vessels-types'
import { COLORS } from '~theme/colors'
import { downloadFile } from '~utils/download-file'
import { useGetVesselFileUrl } from '../use-get-vessel-file-url'

export function UploadedFile({
  file,
  sectionId,
  vesselId,
  onDelete,
}: {
  file: IVesselFile
  sectionId: string
  vesselId: string
  onDelete?: () => void
}) {
  const { refetch: fetchDocumentUrl } = useGetVesselFileUrl({
    vesselId,
    fileName: file.filename,
    sectionId,
  })

  const onClickHandler = async () => {
    const { data: url } = await fetchDocumentUrl()
    if (url) {
      downloadFile({ url: url.signedUrl, title: file.filename })
    }
  }

  return (
    <FileRenderer
      fileName={file.filename}
      onDelete={onDelete}
      onClickHandler={onClickHandler}
    />
  )
}

export function FileRenderer({
  onDelete,
  onClickHandler,
  fileName,
}: {
  onDelete?: () => void
  onClickHandler?: () => void
  fileName: string
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        border: `1px solid ${COLORS.greys.light}`,
        borderRadius: '4px',
        justifyContent: 'space-between',
      }}
    >
      <Box
        sx={{
          maxWidth: '400px',
          width: '100%',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: 'inline-block',
          textAlign: 'left',
          py: 1,
          px: 3,

          '&:hover': {
            color: !!onClickHandler
              ? COLORS.secondary.hoverBlue
              : COLORS.secondary.midBlue,
            cursor: !!onClickHandler ? 'pointer' : 'default',
            '& path': {
              fill: `${COLORS.secondary.midBlue} ${!!onClickHandler ? '' : '!important'}`,
            },
          },
        }}
        component={TextButton}
        onClick={onClickHandler}
      >
        {fileName}
      </Box>
      {onDelete && (
        <IconButton disableRipple onClick={onDelete}>
          <DeleteIcon width="16px" height="16px" color={COLORS.red.mid} />
        </IconButton>
      )}
    </Box>
  )
}
